var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorSpeechIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9.098 0 0 7.948 0 18C0 28.052 9.098 36 20 36C20.692 36 21.33 35.862 22 35.8V42.2L25.082 40.224C29.406 37.448 38.77 30.244 39.882 19.904C39.958 19.2721 39.9974 18.6364 40 18C40 7.948 30.902 0 20 0ZM20 4C28.982 4 36 10.38 36 18C35.9993 18.4833 35.9705 18.9661 35.914 19.446C35.222 25.846 30.098 30.874 26.004 34.154V31.144L23.604 31.628C22.418 31.8716 21.2107 31.9962 20 32C11.018 32 4 25.62 4 18C4 10.38 11.018 4 20 4Z",
    fill: "#B30200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSpeechIcon);
export default __webpack_public_path__ + "static/media/errorSpeechIcon.f1c821aea2c4abc82f230e831a5de3a2.svg";
export { ForwardRef as ReactComponent };